export default defineNuxtRouteMiddleware(to => {
    const { whiteLabel } = useWhiteLabel();
    const routeWhiteLabel = to.meta?.whiteLabel;
    if (routeWhiteLabel && routeWhiteLabel !== whiteLabel) {
        return false;
    }
});
